var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGestor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-gestor",
    transform: "translate(-40 -200)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    transform: "translate(40 200)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2949",
    "data-name": "Path 2949",
    d: "M15.745,14.944V16.6H5.8V14.944s0-3.315,4.972-3.315,4.972,3.315,4.972,3.315M13.259,7.486a2.486,2.486,0,1,0-2.486,2.486,2.486,2.486,0,0,0,2.486-2.486m2.652,4.193A4.641,4.641,0,0,1,17.4,14.944V16.6h2.486V14.944s0-2.859-3.978-3.265M14.916,5a2.411,2.411,0,0,0-.738.116,4.143,4.143,0,0,1,0,4.74,2.411,2.411,0,0,0,.738.116,2.486,2.486,0,1,0,0-4.972M6.629,9.143H4.143V6.657H2.486V9.143H0V10.8H2.486v2.486H4.143V10.8H6.629Z",
    transform: "translate(40.056 199.199)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGestor);
export default __webpack_public_path__ + "static/media/icon-gestor.cdaca656e48f8f4f1173cdb008a80945.svg";
export { ForwardRef as ReactComponent };